import { getRequiredValidator } from "./required";
import { getMaxLengthValidator, getMinLengthValidator, getPatternValidator } from "./rawValidators";
const minLength = 3;
const maxLength = 8;
export const defaultInvoicePrefixValueName = 'Invoice prefix';
export const getInvoicePrefixLengthError = (valueName, min, max) => "".concat(valueName, " must be ").concat(min, "-").concat(max, " letters");

/** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */
export const getInvoicePrefixValidator = function getInvoicePrefixValidator() {
  let valueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInvoicePrefixValueName;
  let required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : maxLength;
  return value => {
    const requiredError = getRequiredValidator(required)(value);
    if (requiredError !== true) {
      return requiredError;
    }
    if (!getMinLengthValidator(minLength)(value)) {
      return getInvoicePrefixLengthError(valueName, minLength, maxLimit);
    }
    if (!getMaxLengthValidator(maxLimit)(value)) {
      return getInvoicePrefixLengthError(valueName, minLength, maxLimit);
    }
    if (!getPatternValidator(/^[a-zA-Z]*$/)(value)) {
      return getInvoicePrefixLengthError(valueName, minLength, maxLimit);
    }
    return true;
  };
};

/** For react-hook-form library. */
export const invoicePrefixValidation = function invoicePrefixValidation(valueName) {
  let {
    required,
    maxLimit
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    validate: {
      invoicePrefix: getInvoicePrefixValidator(valueName, required, maxLimit)
    },
    dataAttr: {
      'data-validation': 'invoice-prefix'
    }
  };
};